import React, { useEffect, useState } from "react";

import CardBookClub from "../../molecules/card-book-club/cardBookClub";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";


import "./bookShelvesAudio.scss";
import { useHandleClickOutside } from "../../../utils/generalUtilities";

interface BookshelvesAudioProps extends ReferenciaContenido {
  nombreCategoria: string;
  referenciaContenido: any;
}

const BookshelvesAudio = (props: BookshelvesAudioProps) => {
  const {
    referenciaPlantillaContenido,
    tituloGeneral,
    tipoComponente
  } = props;

  const [booksToShow, setBooksToShow] = useState<Array<any>>([]);
  const [menuBookSelected, setMenuBookSelected] = useState(-1);
  const {isBrowser } = useBrowserMode();

  useEffect(() => {
    const auxBooks =
      referenciaPlantillaContenido.length > 10
        ? referenciaPlantillaContenido.slice(0, 10)
        : referenciaPlantillaContenido;
    setBooksToShow(auxBooks);
  }, [referenciaPlantillaContenido]);

  useHandleClickOutside(isBrowser, () => setMenuBookSelected(-1), "m-card-book-club__icon");

  const seeMore = () => {
    const booksLeft = referenciaPlantillaContenido.length - booksToShow.length;
    if (booksLeft >= 10) {
      setBooksToShow(
        referenciaPlantillaContenido.slice(0, booksToShow.length + 10)
      );
    } else {
      setBooksToShow(referenciaPlantillaContenido);
    }
  };

  return (
    <section className="o-bookshelves-audio">
      <h2 className="o-bookshelves-audio__title">{tituloGeneral}</h2>
      <div className="o-bookshelves-audio__books-section">
        <div className="o-bookshelves-audio__books-section__titles">
          <p>Título</p>
          {
            tipoComponente === "PlayList" ? "" : <p>Sesión y Fecha</p>
          }
          <p>Acciones</p>
        </div>
        <div className="o-bookshelves-audio__books-section__books">
          {booksToShow &&
            booksToShow.map((book, index) => (
              <CardBookClub
                {...book}
                key={index}
                selected={index === menuBookSelected}
                setSelected={setMenuBookSelected}
                index={index}
                gtmMark={`gtm${normalizeTwoWords(
                  props.nombreCategoria
                )}`}
                cardAudio={book.cardAudio || false}
                audio={book?.audioPrincipal?.file?.url || null}
                marqueeText={book?.tipoTitulo}
              />
            ))}
        </div>
      </div>
      {referenciaPlantillaContenido.length > booksToShow.length && (
        <div className="o-bookshelves-audio__see-more">
          <button
            className="o-bookshelves-audio__see-more__cta"
            onClick={() => seeMore()}
          >
            Ver más
          </button>
        </div>
      )}
    </section>
  );
};

export default BookshelvesAudio;
